import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import ru from './locales/ru.json';

i18n.use(initReactI18next).init({
  resources: {
    en,
    ru,
  },
  debug: process.env.NODE_ENV === 'development',
  lng: 'en',
  fallbackLng: ['en', 'ru'],

  interpolation: {
    escapeValue: false,
  },
});
